import React, { useMemo } from 'react';
import KpisCuadreSection from './KpisCuadreSection';
import AbortadosSection from './AbortadosSection';
import DetalleComparativoSection from './DetalleComparativoSection';
import DailyChartsSection from './DailyChartsSection';

// Contenido del reporte "Lotes vs. Ciclos".
// Recibe los hooks ya cargados desde la página padre y los pasa a la sección.
const LotesVsCiclosContent = ({ hooks, dateRange, startDate, endDate }) => {
  const daysInRange = useMemo(() => {
    if (!startDate || !endDate) return 0;
    const s = new Date(startDate);
    const e = new Date(endDate);
    if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return 0;
    const diff = Math.round((e.setHours(0, 0, 0, 0) - s.setHours(0, 0, 0, 0)) / 86400000);
    return Math.max(diff + 1, 0);
  }, [startDate, endDate]);

  return (
    <div className="space-y-4">
      <KpisCuadreSection kpisCuadre={hooks.kpisCuadre} daysInRange={daysInRange} />
      <AbortadosSection abortados={hooks.abortados} />
      <DetalleComparativoSection participacion={hooks.participacion} />
      <DailyChartsSection kpisCuadre={hooks.kpisCuadre} />
      {/* Pendiente por integrar:
          <DetalleDiferenciasSection detalle={hooks.detalleDiferencias} />
      */}
    </div>
  );
};

export default LotesVsCiclosContent;
